
import Vue from 'vue'
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {IOrderLog} from "@/model/Order/orderInterfaces";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {DateHelper} from "@/helpers/DateHelper";

const ACTION_COLORS: { [key: number]: string } = {
  101: 'created', 102: 'created', 103: 'created',
  106: 'payment',
  115: 'movement', 121: 'movement', 122: 'movement', 145: 'movement', 147: 'movement',
  150: 'deleted',
  160: 'finalized',
  300: 'confirmed', 310: 'confirmed', 330: 'confirmed', 331: 'confirmed',
  629: 'unpaid',
  700: 'spike-error',
};

@Component({ name: 'OOLogs' })
export default class OOLogs extends Vue {

  @Prop()
  protected items!: IOrderLog[];
  @Prop({ default: null })
  protected timezone!: string | null;

  protected expanded: boolean = false;

  protected get orderedItems(): IOrderLog[] {
    return this.items.slice().sort(function (a, b) {
      return a.created_at < b.created_at ? 1 : -1;
    });
  }

  protected get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('common.when'), align: 'start', sortable: false, value: 'created_at' },
      { text: this.$t('common.description'), align: 'start', sortable: false, value: 'description' },
      { text: this.$t('common.details'), align: 'start', sortable: false, value: 'data' },
    ];
  }

  protected formatDate(raw: string): string {
    if (!raw) return '—';
    if (this.timezone) return DateHelper.shortDateFormatTz(raw, this.timezone);
    const d = new Date(raw);
    const day = d.getDate();
    const month = d.getMonth() + 1;
    const year = d.getFullYear();
    return (day < 10 ? '0' + day : '' + day) + '/' +
           (month < 10 ? '0' + month : '' + month) + '/' +
           ('' + year).slice(2);
  }

  protected formatTime(raw: string): string {
    if (!raw) return '';
    if (this.timezone) {
      const t = DateHelper.timeFormatTz(raw, this.timezone);
      return this.timezone === 'Europe/London' ? t + ' · UK' : t;
    }
    const d = new Date(raw);
    const h = d.getHours();
    const m = d.getMinutes();
    return (h < 10 ? '0' + h : '' + h) + ':' + (m < 10 ? '0' + m : '' + m);
  }

  protected actionClass(action: number): string {
    return 'ool-action-badge--' + (ACTION_COLORS[action] || 'default');
  }

  protected hasData(log: IOrderLog): boolean {
    return Object.keys(this.getData(log)).length > 0;
  }

  protected getData(log: IOrderLog): { [key: string]: string } {
    const ret: any = {};
    if (!log.data) return ret;
    const d = JSON.parse(JSON.stringify(log.data));
    Object.keys(d).sort(function (a, b) { return a.localeCompare(b); }).forEach((each) => {
      let label = 'orders.order.logs.fields.' + each;
      let key: string = this.$t(label).toString();
      if (key === label) {
        label = 'common.logs.fields.' + each + '.label';
        key = this.$t(label).toString();
        if (key === label) key = each;
      }
      let v = d[each];
      if (each === 'o') {
        let tLabel = 'orders.order.logs.fields.o.values.' + v;
        let t = this.$t(tLabel).toString();
        if (t !== tLabel) { v = t; }
        else {
          tLabel = 'common.logs.fields.o.values.' + v;
          t = this.$t(tLabel).toString();
          if (t !== tLabel) v = t;
        }
      }
      ret[key] = v;
    });
    return ret;
  }

  protected onToggle() {
    this.expanded = !this.expanded;
  }
}
